import {Brand} from '../../brands/core/_models'

type Props = {
  brand: Brand
  className: string
}

const BrandIcon : React.FC<Props> = ({brand, className}) => (
  <i
    className={`${brand.icon} ${className}`}
    style={{color: brand.color}}>
  </i>
)

export default BrandIcon
